<template>
  <div class="hb-more">
    <div v-if="hbData.length > 0" class="kb-dd">
      <div v-if="hbData.length > 0" class="breder">
        <div class="list-t">
          <Grid :cols="3" col-margin="0.64rem" row-margin="0.64rem">
            <GridItem v-for="(item, index) in hbData" :key="index">
              <img
                :src="$env.ossUrl(item.book.thumbCoverPath)"
                class="book-cover"
                @click="toBook(item.bookId)"
              />
            </GridItem>
          </Grid>
        </div>
      </div>
      <div class="di-word">已经到底啦～</div>
    </div>
    <!-- 都没得数据的时候 -->
    <div v-if="hbData.length <= 0" class="no_data">
      <img src="https://img.yzcdn.cn/upload_files/2020/09/10/FlHmJIcJSeT7o0b6XL8JyOvlWYc0.png" />
    </div>
  </div>
</template>

<script>
import Grid from '@/components/Grid'
import { hbMzDianDuList } from '@/api/diandu'
import { mapState } from 'vuex'
export default {
  name: '',
  components: {
    Grid,
    GridItem: Grid.item
  },
  data() {
    return {
      hbData: []
    }
  },
  computed: {
    ...mapState('user', ['userPref']),
    grade() {
      return this.userPref.wbGrade
    }
  },
  watch: {
    grade: {
      handler(newVal, oldVal) {
        this.getList(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.getList(this.grade)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  },
  methods: {
    getList(grade) {
      var selectedGrade = grade.substr(grade.length - 2, 1)
      var selectedTerm = grade.substr(grade.length - 1, 1)
      var type = ''
      if (this.type && this.type === 'hb') {
        type = 'huibendiandu'
      } else {
        type = 'mingzhuyuedu'
      }
      hbMzDianDuList(type, selectedGrade, selectedTerm).then((res) => {
        this.hbData = res
      })
    },
    toBook(id) {
      this.$router.push({
        path: '/dianDuBooks',
        query: { id: id }
      })
    }
  }
}
</script>

<style lang="scss">
.hb-more {
  .no_data {
    background: #fff;
    margin-top: 7px;
    display: flex;
    justify-content: center;
    height: calc(100vh - 73px);
    img {
      width: 168px;
      height: 196px;
      margin-top: 70px;
    }
  }
  .kb-dd {
    margin-top: 15px;
    .breder {
      border-radius: 18px 18px 0px 0px;
      padding-bottom: 29px;
      background: #ffffff;
      .more {
        border: 0.5px solid rgba(255, 54, 71, 0.5);
        box-sizing: border-box;
        border-radius: 8px;
        height: 49px;
        font-weight: normal;
        font-size: 17px;
        line-height: 49px;
        color: #ff3647;
        text-align: center;
        width: 337px;
        margin: 0 auto;
        margin-top: 39px;
      }
      .list-t {
        padding: 20px 19px 0;
      }
      .book-list {
        padding: 23px 19px 0px;
        .list {
          margin-top: 9px;
        }

        .title-s {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 18px;
          img {
            width: 23px;
            margin-right: 7px;
          }
        }
      }
    }
    .title {
      height: 58.5px;
      font-weight: 500;
      font-size: 18px;
      text-align: center;
      line-height: 58.5px;
    }
    .book-cover {
      width: 98px;
      height: 133px;
    }
    .di-word {
      font-size: 12px;
      text-align: center;
      color: #bec2c6;
      margin-top: 14px;
      padding-bottom: 20px;
    }
  }
}
</style>
